import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Plus, CheckCircle2, Trash2 } from "lucide-react";

export default function Tarefas() {
  const [items, setItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", customer_id: "", due_date: "", notes: "" });

  const load = async () => { const [t, c] = await Promise.all([api.get("/tasks"), api.get("/customers")]); setItems(t.data); setCustomers(c.data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.title || !form.due_date) return toast.error("Título e data são obrigatórios");
    await api.post("/tasks", { ...form, customer_id: form.customer_id || null }); toast.success("Tarefa criada");
    setOpen(false); setForm({ title:"", customer_id:"", due_date:"", notes:"" }); load();
  };
  const complete = async (id) => { await api.patch(`/tasks/${id}/status`, { status: "concluida" }); load(); };
  const del = async (id) => { await api.delete(`/tasks/${id}`); load(); };

  const isOverdue = (t) => t.status === "pendente" && new Date(t.due_date) < new Date();

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold">Tarefas</h1>
          <p className="text-slate-400 text-sm mt-1">Follow-ups e ações pendentes</p>
        </div>
        <Button onClick={()=>setOpen(true)} className="bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold shrink-0" data-testid="task-new-btn"><Plus size={16} className="sm:mr-2"/><span className="hidden sm:inline">Nova tarefa</span></Button>
      </div>

      <div className="grid gap-2">
        {items.length === 0 && <div className="text-slate-500 text-sm">Sem tarefas.</div>}
        {items.map((t) => {
          const c = customers.find((x)=>x.id===t.customer_id);
          return (
            <div key={t.id} className="bg-[#111622] border border-[#1E293B] rounded-lg p-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:justify-between" data-testid={`task-${t.id}`}>
              <div className="min-w-0">
                <div className="font-medium">{t.title}</div>
                <div className="text-xs text-slate-400 mt-1">{c?.name || "—"} · Vence {new Date(t.due_date).toLocaleDateString("pt-BR")}</div>
                {t.notes && <div className="text-xs text-slate-500 mt-1">{t.notes}</div>}
              </div>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className={isOverdue(t) ? "border-red-500/40 text-red-400" : t.status === "concluida" ? "border-emerald-500/40 text-emerald-400" : "border-slate-700 text-slate-300"}>
                  {isOverdue(t) ? "Atrasada" : t.status}
                </Badge>
                {t.status === "pendente" && <Button size="sm" variant="outline" onClick={()=>complete(t.id)} className="border-[#0CDBF2]/40 text-[#0CDBF2]" data-testid={`task-done-${t.id}`}><CheckCircle2 size={14}/></Button>}
                <Button size="sm" variant="outline" onClick={()=>del(t.id)} className="border-slate-700" data-testid={`task-del-${t.id}`}><Trash2 size={14}/></Button>
              </div>
            </div>
          );
        })}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0F17] border-slate-800 text-slate-100">
          <DialogHeader><DialogTitle>Nova tarefa</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-slate-300 text-sm">Título*</Label>
              <Input value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})} className="bg-[#07090E] border-slate-800 mt-1.5" data-testid="task-title"/></div>
            <div><Label className="text-slate-300 text-sm">Cliente</Label>
              <select value={form.customer_id} onChange={(e)=>setForm({...form,customer_id:e.target.value})} data-testid="task-customer"
                className="w-full mt-1.5 bg-[#07090E] border border-slate-800 h-10 px-3 text-sm rounded-md">
                <option value="">— sem cliente —</option>
                {customers.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select></div>
            <div><Label className="text-slate-300 text-sm">Data limite*</Label>
              <Input type="date" value={form.due_date} onChange={(e)=>setForm({...form,due_date:e.target.value})} className="bg-[#07090E] border-slate-800 mt-1.5" data-testid="task-due"/></div>
            <div><Label className="text-slate-300 text-sm">Observações</Label>
              <Textarea value={form.notes} onChange={(e)=>setForm({...form,notes:e.target.value})} className="bg-[#07090E] border-slate-800 mt-1.5" data-testid="task-notes"/></div>
            <Button onClick={create} className="w-full bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E] font-semibold" data-testid="task-save">Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
